import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import './assets/fonts/Futura-Medium.ttf';
import './index.css';

import Routes from './routes';
import store from './store';
import Loader from './components/layout/Loader';
import { APIInterceptor } from './http';

APIInterceptor(store);

ReactDOM.render(
  <Provider store={store}>
    <Loader />
    <Routes />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
